module.exports = __webpack_public_path__ + "static/homepage-wholesale-sections-manager-579d205f4be4e89c1757419434f0b174.png";